module.exports = __webpack_public_path__ + "img/icon_edit.485a9470.svg";